import { useMemo } from "react";
import { FormikProvider } from "formik";
import { useActionChoices } from "stores";
import { ActionCause } from "components";
import { ACTION_VIEW_MODE } from "constants/action-form";
import { ACTION_STATUS } from "constants/actions";
import { useActionModalGetContext } from "context/ActionModalProvider";
import AnalysisHeader from "../header/analysis-header/AnalysisHeader";
import AnalysisBaseInfo from "../base-info/AnalysisBaseInfo";
import { useAnalysisFormikSetup } from "../utils/useFormikSetup";
import AnalysisDetails from "../details/analysis/AnalysisDetails";
import { ActionReadyFormStyled } from "../common-styled/ActionReadyFormStyled";
import ActionMediaSection from "../media-library/ActionMediaSection";

const operationsWithAnalysisTable = ["soilSampling", "leafAnalysis"];

const AnalysisReadyContent = ({ selectedField, onClose, type }) => {
  const { isSpecificOperation } = useActionChoices();

  const { action } = useActionModalGetContext();

  const shouldShowMedia = useMemo(() => {
    const isNewAction = action.type === ACTION_VIEW_MODE.new;
    if (isNewAction) return false;

    const isNotPerformed =
      action.status !== ACTION_STATUS.performed &&
      action.status !== ACTION_STATUS.failed;
    if (isNotPerformed) return false;

    return true;
  }, [action.status, action.type]);

  const { formik, isLoading } = useAnalysisFormikSetup({
    selectedField,
    onClose,
    type,
  });

  const shouldShowMediaAboveTable = useMemo(() => {
    const operationTypeId = formik?.values?.diagnoseAction?.operationTypeId;

    return operationsWithAnalysisTable.some((operation) =>
      isSpecificOperation(operation, operationTypeId),
    );
  }, [formik?.values?.diagnoseAction?.operationTypeId, isSpecificOperation]);

  return (
    <FormikProvider value={formik}>
      <ActionReadyFormStyled onSubmit={formik.handleSubmit}>
        <AnalysisHeader isLoading={isLoading} />
        <div className="action-modal-form-inner">
          <div className="action-modal-card">
            <div className="action-modal-top-box">
              <AnalysisBaseInfo
                // viewMode={action.type}
                viewMode={ACTION_VIEW_MODE.new}
              />
            </div>
            <div className="action-modal-top-box">
              <ActionCause
                // viewMode={action.type}
                viewMode={ACTION_VIEW_MODE.new}
              />
            </div>
          </div>
          {shouldShowMedia && shouldShowMediaAboveTable && (
            <div className="action-modal-card" style={{ paddingBottom: 0 }}>
              <ActionMediaSection />
            </div>
          )}
          <div className="action-details-wrapper">
            <AnalysisDetails
              // viewMode={action.type}
              viewMode={ACTION_VIEW_MODE.new}
            />
          </div>
          {shouldShowMedia && !shouldShowMediaAboveTable && (
            <div className="action-modal-card" style={{ paddingBottom: 0 }}>
              <ActionMediaSection />
            </div>
          )}
        </div>
      </ActionReadyFormStyled>
    </FormikProvider>
  );
};

export default AnalysisReadyContent;
